/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";
export const GrupoSCH = (perPage)=> {
    let filtro = new Filtro();
    filtro.perPage = perPage;
    filtro.fields = ['descricao', 'perc_comissao'];
    filtro.addOrder('descricao', 'asc');
  return filtro
};
